export const HIGHEST_VOLUME = "HIGHEST_VOLUME";
export const HIGHEST_VOLUME_STREAM = "HIGHEST_VOLUME_STREAM";
